import http from "../plugins/axios"

export const getTemplateMember = async (params) => {
  try {
    const response = await http.get(`/participant/user-events/templates`, { params })
    return response.data
  } catch (error) {
    throw error
  }
}
export const getDetailTemplateMember = async (templateId) => {
  try {
    const response = await http.get(`/participant/user-events/templates/${templateId}`)
    return response.data
  } catch (error) {
    throw error
  }
}